import { render } from "./PMyRelease.vue?vue&type=template&id=06ae0a27&scoped=true"
import script from "./PMyRelease.vue?vue&type=script&lang=js"
export * from "./PMyRelease.vue?vue&type=script&lang=js"

import "./PMyRelease.vue?vue&type=style&index=0&id=06ae0a27&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ae0a27"]])

export default __exports__